import { ADD_ACTION } from "constants/actions";
import { AGENCY_DPWH_ID } from "constants/agency";
import {
  ADDITIONAL_ALLOCATION_TYPE_ID,
  ALLOCATION_TYPE_FILTER,
  ATC_ALLOCATION_TYPE_ID,
  CONTINUING_ALLOCATION_TYPE_ID,
  OTHERS_ALLOCATION_TYPE_ID,
} from "constants/budgetAllocation";
import { congRoles } from "utility/constants";

export const defaultProjectRecipients = {
  recipientName: "",
  budgetAllocation: "",
  allocationType: ADDITIONAL_ALLOCATION_TYPE_ID,
};

export const withAllocationDetails = [
  ATC_ALLOCATION_TYPE_ID,
  OTHERS_ALLOCATION_TYPE_ID,
];

const filteredAllocationIds = [
  ATC_ALLOCATION_TYPE_ID,
  OTHERS_ALLOCATION_TYPE_ID,
  ADDITIONAL_ALLOCATION_TYPE_ID,
];

const allocationIds = [
  ATC_ALLOCATION_TYPE_ID,
  OTHERS_ALLOCATION_TYPE_ID,
  ADDITIONAL_ALLOCATION_TYPE_ID,
  CONTINUING_ALLOCATION_TYPE_ID,
];

const houseSpeakerAllocationOptions = [
  OTHERS_ALLOCATION_TYPE_ID,
  ADDITIONAL_ALLOCATION_TYPE_ID,
];

export const filteredAllocationTypes = ALLOCATION_TYPE_FILTER?.filter((op) =>
  filteredAllocationIds.includes(op.value)
);

export const allocationTypeOptions = ALLOCATION_TYPE_FILTER?.filter((op) =>
  allocationIds.includes(op.value)
);

export const houseSpeakerAllocationTypeOptions = ALLOCATION_TYPE_FILTER?.filter(
  (op) => houseSpeakerAllocationOptions.includes(op.value)
);

export const acceptedFileTypes = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/pdf",
];

export const CONGRESSMAN_BOJIE_DY_ID = 397;

export const CONGRESSMAN_MARTIN_ROMUALDEZ_ID = 234;

export const CONGRESSMAN_YEDDA_ROMUALDEZ_ID = 235;

export const CONGRESSMAN_JUDE_ACIDRE_ID = 5;

export const ATCcongs = [
  CONGRESSMAN_MARTIN_ROMUALDEZ_ID,
  CONGRESSMAN_JUDE_ACIDRE_ID,
  CONGRESSMAN_YEDDA_ROMUALDEZ_ID,
  CONGRESSMAN_BOJIE_DY_ID,
];

export const big3Congs = [
  CONGRESSMAN_MARTIN_ROMUALDEZ_ID,
  CONGRESSMAN_YEDDA_ROMUALDEZ_ID,
  CONGRESSMAN_JUDE_ACIDRE_ID,
];

const nonAtcAllocationIds = [
  OTHERS_ALLOCATION_TYPE_ID,
  ADDITIONAL_ALLOCATION_TYPE_ID,
  CONTINUING_ALLOCATION_TYPE_ID,
];

export const nonAtcAllocationTypeOptions = ALLOCATION_TYPE_FILTER?.filter(
  (op) => nonAtcAllocationIds.includes(op.value)
);

export const ADD_PROGRAM = "addProgram";

export const isSendRequestFormShown = (
  action,
  selectedProject,
  selectedAgency,
  isFormLoading
) => {
  return (
    action === ADD_ACTION ||
    selectedProject ||
    selectedAgency?.value === 14 ||
    !isFormLoading
  );
};

export const isFormEnabled = (
  isLoading,
  action,
  selectedAgency,
  projectDetailsFormData,
  selectedProject,
  projectRecipients
) => {
  let isDisabled = false;

  if (isLoading) return true;

  if (selectedAgency === null) {
    isDisabled = true;
  }

  if (action === ADD_ACTION && projectDetailsFormData.projectName === "") {
    isDisabled = true;
  }

  if (action === "" && !selectedProject && selectedAgency?.value !== 14) {
    isDisabled = true;
  }

  projectRecipients?.forEach((recipient) => {
    if (
      !recipient?.recipientName?.value ||
      recipient?.budgetAllocation === ""
    ) {
      isDisabled = true;
    }

    if (!recipient.recipientName?.region) {
      isDisabled = true;
    }
  });

  return isDisabled;
};

export const isAddProgramIconShown = (action, role, selectedAgency) =>
  action !== ADD_ACTION &&
  !congRoles.includes(role) &&
  selectedAgency?.value !== AGENCY_DPWH_ID;

export const POSITION_OPTIONS = [
  {
    value: 1,
    label: "Senator",
  },
  {
    value: 2,
    label: "Governor",
  },
  {
    value: 3,
    label: "Vice Governor",
  },
  {
    value: 4,
    label: "Mayor",
  },
  {
    value: 5,
    label: "Vice Mayor",
  },
  {
    value: 6,
    label: "Others",
  },
];
